<div
  class="min-h-screen pb-page-bottom"
  [style.backgroundColor]="backgroundColor | contentBuilderColor"
  [style.backgroundImage]="backgroundImageCss"
  [style.backgroundSize]="backgroundImageCss ? 'cover' : null"
  [style.backgroundPosition]="backgroundImageCss ? 'center' : null"
  [style.backgroundRepeat]="backgroundImageCss ? 'no-repeat' : null"
>
  <app-block-list [blockIdList]="top"></app-block-list>
  @if (orderTimeWarningMessage) {
    <div
      class="mx-4 mb-4 rounded-lg bg-primary-100 px-4 py-3 text-center text-primary-800 lg:mx-auto lg:max-w-4xl"
    >
      <span class="font-medium">{{ orderTimeWarningMessage }}</span>
    </div>
  }
  <div
    class="mt-6 grid max-w-full grid-cols-1 gap-6 md:gap-12 lg:mx-auto lg:max-w-4xl lg:grid-cols-2 lg:gap-6"
  >
    <div class="cart-page-column mx-4 lg:mx-0">
      <app-block-list [blockIdList]="left"></app-block-list>
    </div>
    <div class="cart-page-column mx-4 pt-3 lg:mx-0 lg:pt-0">
      <app-block-list [blockIdList]="right"></app-block-list>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
